"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketService = void 0;
const tsyringe_1 = require("tsyringe");
const fetchRoomService_1 = require("../../../utils/services/fetchRoomService/fetchRoomService");
const socket_io_client_1 = require("socket.io-client");
const payloadService_1 = require("../payloadService/payloadService");
const messageService_1 = require("../messageService/messageService");
const crypto_1 = require("crypto");
let WebsocketService = class WebsocketService {
    constructor(fetchRoomService, payloadSerivce, messageService) {
        this.fetchRoomService = fetchRoomService;
        this.payloadSerivce = payloadSerivce;
        this.messageService = messageService;
        this.websockets = {};
        this.joinSection = (parameters) => __awaiter(this, void 0, void 0, function* () {
            const { roomId, sectionId } = parameters;
            yield this.connectToWebSocket(roomId);
            yield this.subscribeToRoom(roomId, sectionId);
        });
        this.subscribeToRoom = (roomId, sectionId) => __awaiter(this, void 0, void 0, function* () {
            const params = {
                sectionId,
                roomId
            };
            const payload = yield this.payloadSerivce.hydratePayloadParameters(params);
            const tokenContent = yield this.fetchRoomService.fetchRoom(roomId);
            const notificationEndpointHash = this.hashString(tokenContent.notificationEndpoint);
            this.websockets[notificationEndpointHash].emit('joinRoom', payload);
        });
        this.connectToWebSocket = (roomId) => __awaiter(this, void 0, void 0, function* () {
            const tokenContent = yield this.fetchRoomService.fetchRoom(roomId);
            const { notificationEndpoint } = tokenContent;
            if (!notificationEndpoint) {
                throw new Error('there is no notification endpoint');
            }
            const notificationEndpointHash = this.hashString(notificationEndpoint);
            if (!this.websockets[notificationEndpointHash]) {
                this.websockets[notificationEndpointHash] = socket_io_client_1.io(notificationEndpoint);
                this.setWsListeners(notificationEndpointHash);
            }
        });
        this.setWsListeners = (notificationEndpointHash) => {
            this.websockets[notificationEndpointHash].on('connect', () => {
                console.info('ws is connected');
            });
            this.websockets[notificationEndpointHash].on('message', (data) => {
                this.messageService.emitMessage(data);
            });
        };
        this.hashString = (data) => {
            const hash = crypto_1.createHash('sha256');
            hash.update(data);
            return hash.digest('hex');
        };
    }
};
WebsocketService = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [fetchRoomService_1.FetchRoomService,
        payloadService_1.PayloadService,
        messageService_1.MessageService])
], WebsocketService);
exports.WebsocketService = WebsocketService;
//# sourceMappingURL=websocketService.js.map